import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
} from "reactstrap";
import {
  createListCustomer,
  createWaybills,
  getAllDocumentList,
  getBillLandingList,
  getCustomerAddressList,
  getDeductionList,
  getDeliveryMethodList,
  getDeliveryNotesList,
  getDocumentSetList,
  getListCountry,
  getListCurrency,
  getListCustomerList,
  getListMainproduct,
  getListSalesmenList,
  getMaturityDatesList,
  getMoloniVehiclesList,
  getTaxList,
  getviewWaybills,
  getWarehouseList,
  updateWaybills,
} from "../../services/MoloniServices";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getCommonSearchList } from "../../services/settingsServices";

const AddWaybills = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);
  const initialTax = { tax_id: 0, value: 0, order: 0, cumulative: 0 };
  const initialChildProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const initialProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const [wayBillData, setWayBillData] = useState({
    id: "",
    moloni_id: "",
    date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    alternate_address_id: "",
    your_reference: "",
    associated_documents: [],
    related_documents_notes: "",
    products: [initialProduct],
    exchange_currency_id: "",
    exchange_rate: "",
    delivery_method_id: "",
    delivery_datetime: "",
    delivery_departure_address: "",
    delivery_departure_city: "",
    delivery_departure_zip_code: "",
    delivery_departure_country: "",
    delivery_destination_address: "",
    delivery_destination_city: "",
    delivery_destination_zip_code: "",
    delivery_destination_country: "",
    vehicle_id: "",
    vehicle_name: "",
    vehicle_number_plate: "",
    notes: "",
    status: 0,
    financial_discount: "",
    eac_id: "",
    associate_document_type: "",
    expiration_date: "",
    customer_iva: 0,
    alternate_address: [],
    actual_date_check: 0,
    save_my_vehicle: 0,
    preset: 0,
    company_check: 0,
    customer_check: 0,
    order_id: "",
    customer_reference: "",
  });

  let errorsObj = {
    date: "",
    document_set_id: "",
    customer_id: "",
    delivery_method_id: "",
    delivery_datetime: "",
    delivery_departure_address: "",
    delivery_departure_city: "",
    delivery_departure_zip_code: "",
    delivery_departure_country: "",
    delivery_destination_address: "",
    delivery_destination_city: "",
    delivery_destination_zip_code: "",
    delivery_destination_country: "",
    expiration_date: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [propertyErrors, setPropertyErrors] = useState([]);
  const [billLadingData, setBillLadingData] = useState("");
  const [exchangeCurrList, setExchangeCurrList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [deductionList, setDeductionList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);
  const [assocDataList, setAssocDataList] = useState([]);
  const [errorsPro, setErrorsPro] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");
  const [alternateAddressList, setAlternateAddressList] = useState([]);
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [customerModel, setCustomerModel] = useState(false);
  const [activeCustomerTab, setActiveCustomerTab] = useState("1");
  const [languageList, setLanguageList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [maturityDatesList, setMaturityDatesList] = useState([]);
  const [priceClassList, setPriceClassList] = useState([]);
  const [salesmenList, setSalesmenDatesList] = useState([]);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [openFinancial, setOpenFinancial] = useState(false);
  const [openNotes, setOpenNotes] = useState(false);
  const [openDelivery, setOpenDelivery] = useState(false);
  const [showCreateVehicle, setShowCreateVehicle] = useState(false);
  const [altForm, setAltForm] = useState({
    description: "",
    code: "",
    address: "",
    zip_code: "",
    city: "",
    country: "",
    email: "",
    phone: "",
    fax: "",
    contact_person: "",
  });

  const [editIndex, setEditIndex] = useState(null);

  const [customerData, setCustomerData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
    moloni_id: "",
    contact_person: "",
    contact_notes: "",
    customer_iva: 0,
    series_id: "",
    price_id: "",
  });
  const [filterList, seFilterList] = useState([]);
  const [salesMenDataList, setSalesMenDataList] = useState([]);

  const [exemptionList, setExemptionList] = useState([]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "exception_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].description,
          });
        }

        setExemptionList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleSelectCustomer = (item) => {
    setSearch(item.name);
    setSelectedCustomerId(item.moloni_id);
  };

  const handleShippingDelete = () => {
    setWayBillData({
      ...wayBillData,
      delivery_method_id: "",
      delivery_departure_address: "",
      delivery_departure_city: "",
      delivery_departure_zip_code: "",
      delivery_departure_country: "",
      delivery_destination_address: "",
      delivery_destination_city: "",
      delivery_destination_zip_code: "",
      delivery_destination_country: "",
      actual_date_check: 0,
      save_my_vehicle: 0,
      preset: 0,
      company_check: 0,
      customer_check: 0,
    });
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    return now.toISOString().slice(0, 16);
  };

  const handleAltChange = (e) => {
    setAltForm({
      ...altForm,
      [e.target.name]: e.target.value,
    });
  };

  const resetAltForm = () => {
    setAltForm({
      description: "",
      code: "",
      address: "",
      zip_code: "",
      city: "",
      country: "",
      email: "",
      phone: "",
      fax: "",
      contact_person: "",
    });
    setEditIndex(null);
  };

  const editAlternateAddress = (index) => {
    setAltForm(wayBillData.alternate_address[index]);
    setEditIndex(index);
  };

  const deleteAlternateAddress = (index) => {
    const updated = wayBillData.alternate_address.filter((_, i) => i !== index);

    setWayBillData({
      ...wayBillData,
      alternate_address: updated,
    });
  };

  const saveAlternateAddress = () => {
    if (
      !altForm.description ||
      !altForm.code ||
      !altForm.address ||
      !altForm.zip_code ||
      !altForm.city ||
      !altForm.country
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    let updatedList = [...wayBillData.alternate_address];

    if (editIndex !== null) {
      updatedList[editIndex] = altForm;
    } else {
      updatedList.push(altForm);
    }

    setWayBillData({
      ...wayBillData,
      alternate_address: updatedList,
    });

    resetAltForm();
  };

  const handleCustomerCloseModel = () => {
    setCustomerModel(false);
  };

  const validateProduct = (product, index) => {
    let newErrors = {};

    if (!product.product_id) newErrors.product_id = "Product is required";
    if (!product.name?.trim()) newErrors.name = "Name is required";
    if (!product.qty || product.qty <= 0)
      newErrors.qty = "Quantity is required";
    if (!product.price || product.price <= 0)
      newErrors.price = "Price is required";

    setErrorsPro((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const handleAddProduct = (e) => {
    e.preventDefault();

    let list = [...wayBillData.products];
    list.push({ ...initialProduct });

    setWayBillData({
      ...wayBillData,
      products: list,
    });
  };

  const handleRemoveProduct = (e, index) => {
    e.preventDefault();

    let list = [...wayBillData?.products];
    list.splice(index, 1);

    setWayBillData({
      ...wayBillData,
      products: list,
    });
  };

  const handleAddChildProduct = (e, productIndex) => {
    e.preventDefault();
    let list = [...wayBillData.products];
    if (!list[productIndex].child_products) {
      list[productIndex].child_products = [];
    }
    list[productIndex].child_products.push({ ...initialChildProduct });
    setWayBillData({ ...wayBillData, products: list });
  };

  const handleRemoveChildProduct = (e, productIndex, childIndex) => {
    e.preventDefault();
    let list = [...wayBillData.products];
    list[productIndex].child_products.splice(childIndex, 1);
    setWayBillData({ ...wayBillData, products: list });
  };

  const handleAddChildProperty = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...wayBillData.products];

    if (!list[productIndex].child_products[childIndex].properties) {
      list[productIndex].child_products[childIndex].properties = [];
    }

    list[productIndex].child_products[childIndex].properties.push({
      title: "",
      value: "",
    });

    setWayBillData({
      ...wayBillData,
      products: list,
    });
  };

  const handleAddChildTax = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...wayBillData.products];

    if (!list[productIndex].child_products[childIndex].taxes) {
      list[productIndex].child_products[childIndex].taxes = [];
    }

    list[productIndex].child_products[childIndex].taxes.push({
      tax_id: null,
      value: 0,
      order: null,
      cumulative: 0,
    });

    setWayBillData({
      ...wayBillData,
      products: list,
    });
  };

  const handleAddTax = (e, productIndex) => {
    e.preventDefault();

    let list = [...wayBillData.products];
    list[productIndex].taxes.push({ ...initialTax });

    setWayBillData({
      ...wayBillData,
      products: list,
    });
  };

  const handleRemoveTax = (e, productIndex, taxIndex) => {
    e.preventDefault();

    let list = [...wayBillData.products];
    list[productIndex].taxes.splice(taxIndex, 1);

    setWayBillData({
      ...wayBillData,
      products: list,
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSalesmenList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSalesmenDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeliveryMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeliveryMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (uuid) {
      let data = { id: uuid };
      getviewWaybills(data)
        .then((response) => {
          setBillLadingData(response.data.data);
        })
        .catch((err) => {
          navigate("/waybills");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    if (billLadingData) {
      setWayBillData({
        id: billLadingData?.id,
        date: billLadingData?.date,
        document_set_id: billLadingData?.document_set_id,
        customer_id: billLadingData?.customer_id,
        alternate_address_id: billLadingData?.alternate_address_id,
        your_reference: billLadingData?.your_reference,
        our_reference: billLadingData?.our_reference,
        associated_documents: billLadingData?.associated_documents,
        related_documents_notes: billLadingData?.related_documents_notes,
        products: billLadingData?.products,
        exchange_currency_id: billLadingData?.exchange_currency_id,
        exchange_rate: billLadingData?.exchange_rate,
        delivery_method_id: billLadingData?.delivery_method_id,
        delivery_datetime: billLadingData?.delivery_datetime,
        delivery_departure_city: billLadingData?.delivery_departure_city,
        delivery_departure_zip_code:
          billLadingData?.delivery_departure_zip_code,
        delivery_departure_country: billLadingData?.delivery_departure_country,
        delivery_destination_address:
          billLadingData?.delivery_destination_address,
        delivery_destination_city: billLadingData?.delivery_destination_city,
        delivery_destination_zip_code:
          billLadingData?.delivery_destination_zip_code,
        delivery_destination_country:
          billLadingData?.delivery_destination_country,
        vehicle_id: billLadingData?.vehicle_id,
        vehicle_name: billLadingData?.vehicle_name,
        vehicle_number_plate: billLadingData?.vehicle_number_plate,
        notes: billLadingData?.notes,
        status: billLadingData?.status,
        financial_discount: billLadingData?.financial_discount,
        eac_id: billLadingData?.eac_id,
        delivery_departure_address: billLadingData?.delivery_departure_address,
        expiration_date: billLadingData?.expiration_date,
        order_id: billLadingData?.order_id,
        customer_reference: billLadingData?.customer_reference,
      });
      setSelectedCustomerId(billLadingData?.customer_id);
    }
  }, [billLadingData]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      type: "m_waybills",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setInvoiceType(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (!wayBillData?.customer_id) {
      return;
    }

    if (Number(wayBillData.associate_document_type) === 1) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: wayBillData.customer_id,
      };

      getDeliveryNotesList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }

    if (Number(wayBillData.associate_document_type) === 3) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: wayBillData.customer_id,
      };

      getBillLandingList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }
  }, [wayBillData, wayBillData?.associate_document_type]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeductionList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeductionList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListMainproduct(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
            price: response.data[i].price,
            stock: response.data[i].stock,
            exemption_reason: response.data[i].exemption_reason,
            taxes: response.data[i].taxes,
            properties: response.data[i].properties,
            warehouse: response.data[i].warehouse,
          });
        }

        setProductList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      const initialProduct = {
        product_id: selectedProduct?.value,
        name: selectedProduct.label || "",
        summary: "",
        qty: selectedProduct.stock || 0,
        price: selectedProduct.price || 0,
        discount: 0,
        deduction_id: "",
        order: 0,
        exemption_reason: "",
        warehouse_id: selectedProduct.warehouse,
        properties: selectedProduct.properties || [],
        taxes: selectedProduct.taxes || [],
      };

      setWayBillData((prev) => ({
        ...prev,
        products: [initialProduct],
      }));
    }
  }, [selectedProduct]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(
    function () {
      if (wayBillData?.customer_id) {
        let data = {
          limit: 20,
          page: 1,
          search: "",
          customer_id: wayBillData?.customer_id,
        };
        getCustomerAddressList(data)
          .then((res) => {
            const response = res.data.address;

            let list = [];
            for (let i = 0; i < response.length; i++) {
              list.push({
                value: response[i].moloni_id,
                label: response[i].name,
              });
            }

            setAlternateAddressList(list);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          });
      }
    },
    [wayBillData],
  );

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCurrency(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setExchangeCurrList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(
    function () {
      let data = {
        limit: 20,
        page: 1,
        search: search ? search : "",
      };
      getListCustomerList(data)
        .then((response) => {
          seCustomerList(response.data.data);
          if (search) {
            seFilterList(response.data.data);
          }
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    },
    [search],
  );

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMoloniVehiclesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].description,
          });
        }

        setVehiclesList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleAddAssociatedDocuments = () => {
    setWayBillData((prev) => {
      const lastAssociatedDocuments =
        prev.associated_documents[prev.associated_documents?.length - 1];

      if (!lastAssociatedDocuments) {
        return {
          ...prev,
          associated_documents: [{ associated_id: "", value: "" }],
        };
      }

      if (
        !lastAssociatedDocuments.associated_id ||
        !lastAssociatedDocuments.value
      ) {
        toast.error(
          "Please complete associate,value before adding another associated documents",
        );
        return prev;
      }

      return {
        ...prev,
        associated_documents: [
          ...prev.associated_documents,
          { associated_id: "", value: "" },
        ],
      };
    });

    // setWayBillData((prev) => ({
    //   ...prev,
    //   associated_documents: [
    //     ...prev.associated_documents,
    //     { associated_id: "", value: "" },
    //   ],
    // }));
  };

  const handleRemoveAssociatedDocuments = (index) => {
    setWayBillData((prev) => ({
      ...prev,
      associated_documents: prev.associated_documents.filter(
        (_, i) => i !== index,
      ),
    }));
  };

  const handleChangeAssociatedDocuments = (index, field, value) => {
    setWayBillData((prev) => {
      const updatedDocs = [...prev.associated_documents];

      if (field === "associated_id") {
        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc && selectedDoc.net_value) {
          updatedDocs[index].value = selectedDoc.net_value;
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, associated_documents: updatedDocs };
    });

    setPropertyErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "associated_id" && !value) {
        errors[index].associated_id = "Associated is required";
      } else if (field === "associated_id") {
        errors[index].associated_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      return errors;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!wayBillData?.date) {
      errorObj.date = `Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    // if (wayBillData?.date && wayBillData?.expiration_date) {
    //   const start = new Date(wayBillData.date);
    //   const end = new Date(wayBillData.expiration_date);

    //   if (end < start) {
    //     errorObj.expiration_date = "Expiration Date must be after Date.";
    //     error = true;
    //   }
    // }

    if (!wayBillData.document_set_id) {
      errorObj.document_set_id = `Document Set is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!wayBillData.customer_id) {
      errorObj.customer_id = `Customer is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!wayBillData.delivery_departure_address) {
      errorObj.delivery_departure_address = `Delivery departure address is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!wayBillData.delivery_departure_city) {
      errorObj.delivery_departure_city = `Delivery departure city is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!wayBillData.delivery_departure_zip_code) {
      errorObj.delivery_departure_zip_code = `Delivery departure zip code is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!wayBillData.delivery_departure_country) {
      errorObj.delivery_departure_country = `Delivery departure country is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!wayBillData.delivery_destination_address) {
      errorObj.delivery_destination_address = `Delivery destination address is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!wayBillData.delivery_destination_city) {
      errorObj.delivery_destination_city = `Delivery destination city is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!wayBillData.delivery_destination_zip_code) {
      errorObj.delivery_destination_zip_code = `Delivery destination zipCode is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!wayBillData.delivery_destination_zip_code) {
      errorObj.delivery_destination_zip_code = `Delivery destination zipCode is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!wayBillData.delivery_destination_country) {
      errorObj.delivery_destination_country = `Delivery destination country is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    if (!wayBillData.delivery_datetime) {
      errorObj.delivery_datetime = `Delivery Date is required.`;
      error = true;
      setBtnLoader(false);
      setOpenDelivery(true);
    }

    // wayBillData?.associated_documents?.forEach((tax, index) => {
    //   let rowError = {};

    //   if (!tax.associated_id) {
    //     rowError.associated_id = "Associate is required.";
    //     error = true;
    //   }
    //   if (!tax.value) {
    //     rowError.value = "Value is required.";
    //     error = true;
    //   }

    //   propertyErrors[index] = rowError;
    // });

    // let allValid = true;
    // wayBillData?.products.forEach((product, i) => {
    //   if (!validateProduct(product, i)) {
    //     allValid = false;
    //   }
    // });

    // if (!allValid) {
    //   toast.error("Product is Required");
    //   return;
    // }

    if (!selectedCustomerId) {
      toast.error("Customer is Required");
      return;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      date: wayBillData?.date,
      document_set_id: wayBillData?.document_set_id,
      customer_id: selectedCustomerId,
      alternate_address_id: wayBillData?.alternate_address_id,
      your_reference: wayBillData?.your_reference,
      associated_documents: wayBillData?.associated_documents,
      related_documents_notes: wayBillData?.related_documents_notes,
      products: wayBillData?.products,
      exchange_currency_id: wayBillData?.exchange_currency_id,
      exchange_rate: wayBillData?.exchange_rate,
      delivery_method_id: wayBillData?.delivery_method_id,
      delivery_datetime: wayBillData?.delivery_datetime,
      delivery_departure_city: wayBillData?.delivery_departure_city,
      delivery_departure_zip_code: wayBillData?.delivery_departure_zip_code,
      delivery_departure_country: wayBillData?.delivery_departure_country,
      delivery_destination_address: wayBillData?.delivery_destination_address,
      delivery_destination_city: wayBillData?.delivery_destination_city,
      delivery_destination_zip_code: wayBillData?.delivery_destination_zip_code,
      delivery_destination_country: wayBillData?.delivery_destination_country,
      vehicle_id: wayBillData?.vehicle_id,
      vehicle_name: wayBillData?.vehicle_name,
      vehicle_number_plate: wayBillData?.vehicle_number_plate,
      notes: wayBillData?.notes,
      status: wayBillData?.status,
      financial_discount: wayBillData?.financial_discount,
      eac_id: wayBillData?.eac_id,
      delivery_departure_address: wayBillData?.delivery_departure_address,
      expiration_date: wayBillData?.expiration_date,
      order_id: wayBillData?.order_id,
      customer_reference: wayBillData?.customer_reference,
    };

    let updateData = {
      id: wayBillData?.id,
      document_id: billLadingData?.document_id,
      date: wayBillData?.date,
      document_set_id: wayBillData?.document_set_id,
      customer_id: selectedCustomerId,
      alternate_address_id: wayBillData?.alternate_address_id,
      your_reference: wayBillData?.your_reference,
      special_discount: wayBillData?.special_discount,
      associated_documents: wayBillData?.associated_documents,
      related_documents_notes: wayBillData?.related_documents_notes,
      products: wayBillData?.products,
      exchange_currency_id: wayBillData?.exchange_currency_id,
      exchange_rate: wayBillData?.exchange_rate,
      delivery_method_id: wayBillData?.delivery_method_id,
      delivery_datetime: wayBillData?.delivery_datetime,
      delivery_departure_city: wayBillData?.delivery_departure_city,
      delivery_departure_zip_code: wayBillData?.delivery_departure_zip_code,
      delivery_departure_country: wayBillData?.delivery_departure_country,
      delivery_destination_address: wayBillData?.delivery_destination_address,
      delivery_destination_city: wayBillData?.delivery_destination_city,
      delivery_destination_zip_code: wayBillData?.delivery_destination_zip_code,
      delivery_destination_country: wayBillData?.delivery_destination_country,
      vehicle_id: wayBillData?.vehicle_id,
      vehicle_name: wayBillData?.vehicle_name,
      vehicle_number_plate: wayBillData?.vehicle_number_plate,
      notes: wayBillData?.notes,
      status: wayBillData?.status,
      financial_discount: wayBillData?.financial_discount,
      eac_id: wayBillData?.eac_id,
      delivery_departure_address: wayBillData?.delivery_departure_address,
      expiration_date: wayBillData?.expiration_date,
      order_id: wayBillData?.order_id,
      customer_reference: wayBillData?.customer_reference,
    };

    if (billLadingData?.id) {
      updateWaybills(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/waybills");
          setBtnLoader(false);

          setWayBillData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          setBtnLoader(false);

          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createWaybills(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/waybills");
          setBtnLoader(false);

          setWayBillData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setBtnLoader(false);
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  const handleCustomerSubmit = (e) => {
    e.preventDefault();

    let data = {
      company_id: "269134",
      vat: customerData?.vat,
      number: customerData?.number,
      name: customerData?.name,
      language_id: customerData?.language_id,
      qty_copies_document: customerData?.qty_copies_document,
      notes: customerData?.notes,
      country_id: customerData?.country_id,
      address: customerData?.address,
      zip_code: customerData?.zip_code,
      city: customerData?.city,
      email: customerData?.email,
      website: customerData?.website,
      phone: customerData?.phone,
      fax: customerData?.fax,
      contact_name: customerData?.contact_name,
      contact_email: customerData?.contact_email,
      contact_phone: customerData?.contact_phone,
      discount: customerData?.discount,
      credit_limit: customerData?.credit_limit,
      payment_method_id: customerData?.payment_method_id,
      delivery_method_id: customerData?.delivery_method_id,
      maturity_date_id: customerData?.maturity_date_id,
      field_notes: customerData?.field_notes,
      salesman_id: customerData?.salesman_id,
      price_class_id: customerData?.price_class_id,
      payment_day: customerData?.payment_day,
      document_type_id: 0,
    };

    createListCustomer(data)
      .then((response) => {
        toast.success(response.data.message);
        setIsModifyButtonLoad(false);
        setCustomerData({
          id: "",
          vat: "",
          number: "",
          name: "",
          language_id: "",
          qty_copies_document: "",
          notes: "",
          country_id: "",
          address: "",
          zip_code: "",
          city: "",
          email: "",
          website: "",
          phone: "",
          fax: "",
          contact_name: "",
          contact_email: "",
          contact_phone: "",
          discount: "",
          credit_limit: "",
          payment_method_id: "",
          delivery_method_id: "",
          maturity_date_id: "",
          field_notes: "",
          salesman_id: "",
          price_class_id: "",
          payment_day: "",
          document_type_id: "",
          moloni_id: "",
        });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
              </div>

              <div className="col-sm-6 text-end">
                <h1 className="page-title">{t("wayBills")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmit}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("issue_date")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control"
                                  type="date"
                                  value={wayBillData.date}
                                  onChange={(e) => {
                                    setWayBillData({
                                      ...wayBillData,
                                      date: e.target.value,
                                    });
                                  }}
                                  name="date"
                                  placeholder="Select Date"
                                />
                              </div>
                              {errors.date && (
                                <span className="input-error">
                                  {errors.date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("documentSet")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={documentSetList}
                                  value={documentSetList.find(
                                    (item) =>
                                      item.value ===
                                      wayBillData.document_set_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setWayBillData({
                                      ...wayBillData,
                                      document_set_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document Set"}
                                />
                                {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3 mt-3">
                          <FormGroup>
                            <Label
                              className="col-form-label ml-2 Label-my form-label form-label"
                              htmlFor="paper_invoice_issuance"
                            ></Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input mt-3"
                                    type="checkbox"
                                    checked={
                                      wayBillData.paper_invoice_issuance === 1
                                    }
                                    onChange={(e) => {
                                      setWayBillData({
                                        ...wayBillData,
                                        paper_invoice_issuance: e.target.checked
                                          ? 1
                                          : 0,
                                      });
                                    }}
                                    id="paper_invoice_issuance"
                                  />
                                  <Label
                                    htmlFor="paper_invoice_issuance"
                                    className="col-form-label ml-2 Label-my form-label form-label mt-1"
                                  >
                                    {t("PaperlessInvoiceIssuance")}
                                  </Label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div>
                          <p>{t("ToIndicateADifferent")}</p>
                        </div>

                        <div className="row">
                          <div
                            className="card"
                            style={{
                              padding: "0px",
                              marginLeft: "15px",
                            }}
                          >
                            <div
                              className="card-header"
                              style={{
                                background: "#81bb42",
                                fontWeight: "600",
                              }}
                            >
                              {t("customers")}
                            </div>
                            <div className="card-body">
                              <div className="row">
                                <div
                                  className="col-md-9 position-relative"
                                  style={{
                                    // marginLeft: "-87px",
                                    padding: "15px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control pe-5"
                                    placeholder="Customers Search"
                                    value={search}
                                    onChange={(e) =>
                                      handleSearch(e.target.value)
                                    }
                                  />
                                  {search && (
                                    <i
                                      className="bi bi-x-circle-fill text-muted"
                                      style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleSearch("")}
                                    ></i>
                                  )}
                                </div>

                                <div className="col-md-2 mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => setCustomerModel(true)}
                                  >
                                    {t("createCustomer")}{" "}
                                    <i className="bi bi-check2"></i>
                                  </button>
                                </div>

                                {filterList?.length > 0 && (
                                  <table className="table table-bordered mt-2">
                                    <thead>
                                      <tr>
                                        <th>Code</th>
                                        <th>Name</th>
                                        <th>Address</th>
                                        <th>VAT Number</th>
                                        <th>Product Price Table</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {filterList?.map((item, index) => (
                                        <tr
                                          key={index}
                                          style={{ cursor: "pointer" }}
                                          className={
                                            selectedCustomerId ===
                                            item.moloni_id
                                              ? "table-active"
                                              : ""
                                          }
                                          onClick={() =>
                                            handleSelectCustomer(item)
                                          }
                                        >
                                          <td>{item.moloni_id}</td>
                                          <td>{item.name}</td>
                                          <td>{item.address}</td>
                                          <td>{item.vat}</td>
                                          <td>
                                            {item.price_class_name || "-"}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="section-box mt-3">
                          <div
                            className={`section-header-green ${
                              openFinancial ? "active" : ""
                            }`}
                            onClick={() => setOpenFinancial(!openFinancial)}
                          >
                            <i
                              className={`bi ${
                                openFinancial
                                  ? "bi-chevron-up"
                                  : "bi-chevron-down"
                              }`}
                            ></i>
                            <span className="ms-2">Financial Data</span>
                          </div>
                          <div
                            className={`collapse ${
                              openFinancial ? "show" : ""
                            }`}
                          >
                            <div className="row mt-3">
                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("orderQuote")}
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={wayBillData.order_id}
                                    onChange={(e) => {
                                      setWayBillData({
                                        ...wayBillData,
                                        order_id: e.target.value,
                                      });
                                    }}
                                    name="order_id"
                                    placeholder="Order/Quote"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("maturity")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        className="my-select-v"
                                        options={maturityDatesList}
                                        value={maturityDatesList.find(
                                          (item) =>
                                            item.value ==
                                            wayBillData.maturity_date_id,
                                        )}
                                        onChange={(selectedOption) => {
                                          setWayBillData({
                                            ...customerData,
                                            wayBillData: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Maturity"}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label
                                    htmlFor="expiration_date"
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                  >
                                    {t("due_date")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control"
                                        type="date"
                                        value={wayBillData.expiration_date}
                                        onChange={(e) => {
                                          setWayBillData({
                                            ...wayBillData,
                                            expiration_date: e.target.value,
                                          });
                                        }}
                                        name="expiration_date"
                                        placeholder="Select Date"
                                      />
                                    </div>
                                    {errors.expiration_date && (
                                      <span className="input-error">
                                        {errors.expiration_date}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("customer_reference")}
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={wayBillData.customer_reference}
                                    onChange={(e) => {
                                      setWayBillData({
                                        ...wayBillData,
                                        customer_reference: e.target.value,
                                      });
                                    }}
                                    name="customer_reference"
                                    placeholder="Customer Reference"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("globalDisc")}(%)
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={wayBillData.special_discount}
                                    onChange={(e) => {
                                      setWayBillData({
                                        ...wayBillData,
                                        special_discount: e.target.value,
                                      });
                                    }}
                                    name="special_discount"
                                    placeholder="Global Disc"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("salesman")}
                                  </Label>
                                  <Select
                                    className="my-select-v"
                                    options={salesMenDataList}
                                    value={salesMenDataList.find(
                                      (item) =>
                                        item.value === wayBillData.salesman_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setWayBillData({
                                        ...wayBillData,
                                        salesman_id: selectedOption
                                          ? selectedOption.value
                                          : "",

                                        salesman_commission: selectedOption
                                          ? selectedOption?.base_commission
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Salesman"}
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("commission")}(%)
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="number"
                                    value={wayBillData.salesman_commission}
                                    onChange={(e) => {
                                      setWayBillData({
                                        ...wayBillData,
                                        salesman_commission: e.target.value,
                                      });
                                    }}
                                    name="salesman_commission"
                                    placeholder="Commission"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("exchange_currency")}
                                  </Label>
                                  <Select
                                    className="my-select-v"
                                    options={exchangeCurrList}
                                    value={exchangeCurrList.find(
                                      (item) =>
                                        item.value ===
                                        wayBillData.exchange_currency_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setWayBillData({
                                        ...wayBillData,
                                        exchange_currency_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Exchange Currency"}
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("exchange_rate")}
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="number"
                                    value={wayBillData.exchange_rate}
                                    onChange={(e) => {
                                      setWayBillData({
                                        ...wayBillData,
                                        exchange_rate: e.target.value,
                                      });
                                    }}
                                    name="exchange_rate"
                                    placeholder="Exchange Rate"
                                  />
                                </FormGroup>
                              </div>
                              <div className="col-md-6" />
                            </div>
                          </div>
                        </div>

                        <div className="section-box">
                          <div
                            className={`section-header-green ${
                              openDelivery ? "active" : ""
                            }`}
                            onClick={() => setOpenDelivery(!openDelivery)}
                          >
                            <i
                              className={`bi ${
                                openDelivery
                                  ? "bi-chevron-up"
                                  : "bi-chevron-down"
                              }`}
                            ></i>
                            <span className="ms-2">
                              Delivery and Transportation
                            </span>
                          </div>

                          <div
                            className={`collapse ${openDelivery ? "show" : ""}`}
                          >
                            <div className="row mt-3">
                              <div className="col-md-6">
                                <p className="fw-semibold fs-5">Delivery</p>
                                <div
                                  class="alert alert-primary py-2"
                                  style={{ background: "#e8f4ff" }}
                                  for="actual_date_check"
                                >
                                  <div
                                    className="form-check"
                                    for="actual_date_check"
                                  >
                                    <input
                                      className="my-checkbox-1 form-check-input"
                                      type="checkbox"
                                      checked={
                                        wayBillData.actual_date_check === 1
                                      }
                                      onChange={(e) => {
                                        const checked = e.target.checked;

                                        setWayBillData({
                                          ...wayBillData,
                                          actual_date_check: checked ? 1 : 0,
                                          delivery_datetime: checked
                                            ? getCurrentDateTime()
                                            : "",
                                        });
                                      }}
                                      id="actual_date_check"
                                    />
                                    <label
                                      class="form-check-label ms-2"
                                      for="actual_date_check"
                                      style={{ color: "black" }}
                                    >
                                      Fill with the actual date and time
                                    </label>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("startShipping")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="datetime-local"
                                          value={
                                            wayBillData.delivery_datetime || ""
                                          }
                                          onChange={(e) => {
                                            setWayBillData({
                                              ...wayBillData,
                                              delivery_datetime: e.target.value,
                                            });
                                          }}
                                          name="delivery_datetime"
                                          placeholder="Start Shipping"
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("delivery")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={deliveryMethodList}
                                          value={deliveryMethodList.find(
                                            (item) =>
                                              item.value ===
                                              wayBillData.delivery_method_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setWayBillData({
                                              ...wayBillData,
                                              delivery_method_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Delivery Method"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("vehicle")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <Select
                                            className="my-select-v"
                                            options={vehiclesList}
                                            value={vehiclesList.find(
                                              (item) =>
                                                item.value ===
                                                wayBillData.vehicle_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              setWayBillData({
                                                ...wayBillData,
                                                vehicle_id: selectedOption
                                                  ? selectedOption.value
                                                  : "",
                                              });
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder={"Select Vehicle"}
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-6 d-flex align-items-end mb-4">
                                    <button
                                      type="button"
                                      className="btn btn-primary w-100"
                                      onClick={() =>
                                        setShowCreateVehicle(!showCreateVehicle)
                                      }
                                    >
                                      Create vehicle{" "}
                                      <i className="bi bi-plus"></i>
                                    </button>
                                  </div>
                                  {showCreateVehicle && (
                                    <>
                                      <div className="row">
                                        <div className="col-md-6">
                                          <Label
                                            htmlFor="vehicle_number_plate"
                                            className="col-form-label ml-2 Label-my form-label form-label"
                                          >
                                            {t("licensePlate")}
                                          </Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              wayBillData.vehicle_number_plate
                                            }
                                            onChange={(e) => {
                                              setWayBillData({
                                                ...wayBillData,
                                                vehicle_number_plate:
                                                  e.target.value,
                                              });
                                            }}
                                            name="vehicle_number_plate"
                                            placeholder="License Plate"
                                          />
                                        </div>

                                        <div className="col-md-6">
                                          <Label
                                            htmlFor="description"
                                            className="col-form-label ml-2 Label-my form-label form-label"
                                          >
                                            Description
                                          </Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={wayBillData.description}
                                            onChange={(e) => {
                                              setWayBillData({
                                                ...wayBillData,
                                                description: e.target.value,
                                              });
                                            }}
                                            name="description"
                                            placeholder="Description"
                                          />
                                        </div>
                                      </div>

                                      <div
                                        className="d-flex align-items-center gap-3 mb-3"
                                        style={{ marginLeft: "15px" }}
                                      >
                                        <div className="form-check mt-3">
                                          <input
                                            type="checkbox"
                                            id="saveMyVehicles"
                                            className="my-checkbox-1 form-check-input"
                                            checked={
                                              wayBillData.save_my_vehicle === 1
                                            }
                                            onChange={(e) => {
                                              const checked = e.target.checked;

                                              setWayBillData({
                                                ...wayBillData,
                                                save_my_vehicle: checked
                                                  ? 1
                                                  : 0,
                                              });
                                            }}
                                          />
                                          <label
                                            htmlFor="saveMyVehicles"
                                            className="form-check-label ms-2"
                                          >
                                            Save on my vehicles
                                          </label>
                                        </div>

                                        <div className="form-check d-flex align-items-center gap-1">
                                          <div className="form-check mt-3">
                                            <input
                                              type="checkbox"
                                              id="preset"
                                              className="my-checkbox-1 form-check-input"
                                              checked={wayBillData.preset === 1}
                                              onChange={(e) => {
                                                const checked =
                                                  e.target.checked;

                                                setWayBillData({
                                                  ...wayBillData,
                                                  preset: checked ? 1 : 0,
                                                });
                                              }}
                                            />
                                            <label
                                              htmlFor="presetCheck"
                                              className="form-check-label ms-2"
                                            >
                                              Preset
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-6">
                                <p className="fw-semibold fs-5">Origin Place</p>

                                <div
                                  class="alert alert-primary py-2"
                                  style={{ background: "#e8f4ff" }}
                                  for="company_check"
                                >
                                  <div
                                    className="form-check"
                                    for="company_check"
                                  >
                                    <input
                                      className="my-checkbox-1 form-check-input"
                                      type="checkbox"
                                      checked={wayBillData.company_check === 1}
                                      onChange={(e) => {
                                        const checked = e.target.checked;

                                        setWayBillData({
                                          ...wayBillData,
                                          company_check: checked ? 1 : 0,
                                        });
                                      }}
                                      id="company_check"
                                    />
                                    <label
                                      class="form-check-label ms-2"
                                      for="company_check"
                                      style={{ color: "black" }}
                                    >
                                      Fill with your company details
                                    </label>
                                  </div>
                                </div>

                                {wayBillData?.company_check === 1 && (
                                  <div className="col-md-12">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("defualt_address")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <Select
                                            className="my-select-v"
                                            options={alternateAddressList}
                                            value={alternateAddressList.find(
                                              (item) =>
                                                item.value ===
                                                wayBillData.alternate_address_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              setWayBillData({
                                                ...wayBillData,
                                                alternate_address_id:
                                                  selectedOption
                                                    ? selectedOption.value
                                                    : "",
                                                delivery_departure_address:
                                                  selectedOption
                                                    ? selectedOption?.address
                                                    : "",
                                                delivery_departure_city:
                                                  selectedOption
                                                    ? selectedOption?.city
                                                    : "",
                                                delivery_departure_zip_code:
                                                  selectedOption
                                                    ? selectedOption?.zip_code
                                                    : "",
                                                delivery_departure_country:
                                                  selectedOption
                                                    ? selectedOption?.country_id
                                                    : "",
                                              });
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder={
                                              "Select Alternate Address"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>
                                )}

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("address")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <textarea
                                          className="form-control input-search"
                                          type="text"
                                          value={
                                            wayBillData.delivery_departure_address
                                          }
                                          onChange={(e) => {
                                            setWayBillData({
                                              ...wayBillData,
                                              delivery_departure_address:
                                                e.target.value,
                                            });
                                          }}
                                          name="delivery_departure_address"
                                          placeholder="Address"
                                          rows={3}
                                        />
                                        {errors.delivery_departure_address && (
                                          <span className="input-error">
                                            {errors.delivery_departure_address}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="row">
                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("zipCode")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <input
                                            className="form-control input-search"
                                            type="text"
                                            value={
                                              wayBillData.delivery_departure_zip_code
                                            }
                                            onChange={(e) => {
                                              setWayBillData({
                                                ...wayBillData,
                                                delivery_departure_zip_code:
                                                  e.target.value,
                                              });
                                            }}
                                            name="delivery_departure_zip_code"
                                            placeholder="Zip Code"
                                          />
                                          {errors.delivery_departure_zip_code && (
                                            <span className="input-error">
                                              {
                                                errors.delivery_departure_zip_code
                                              }
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-8">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("city")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <input
                                            className="form-control input-search"
                                            type="text"
                                            value={
                                              wayBillData.delivery_departure_city
                                            }
                                            onChange={(e) => {
                                              setWayBillData({
                                                ...wayBillData,
                                                delivery_departure_city:
                                                  e.target.value,
                                              });
                                            }}
                                            name="delivery_departure_city"
                                            placeholder="city"
                                          />
                                          {errors.delivery_departure_city && (
                                            <span className="input-error">
                                              {errors.delivery_departure_city}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("country")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={countryList}
                                          value={countryList.find(
                                            (item) =>
                                              Number(item.value) ===
                                              Number(
                                                wayBillData.delivery_departure_country,
                                              ),
                                          )}
                                          onChange={(selectedOption) => {
                                            setWayBillData({
                                              ...wayBillData,
                                              delivery_departure_country:
                                                selectedOption
                                                  ? selectedOption.value
                                                  : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Country"}
                                        />
                                        {errors.delivery_departure_country && (
                                          <span className="input-error">
                                            {errors.delivery_departure_country}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <p className="fw-semibold fs-5">
                                  Delivery Place
                                </p>

                                <div
                                  class="alert alert-primary py-2"
                                  style={{ background: "#e8f4ff" }}
                                  for="customer_check"
                                >
                                  <div
                                    className="form-check"
                                    for="customer_check"
                                  >
                                    <input
                                      className="my-checkbox-1 form-check-input"
                                      type="checkbox"
                                      checked={wayBillData.customer_check === 1}
                                      onChange={(e) => {
                                        const checked = e.target.checked;

                                        setWayBillData({
                                          ...wayBillData,
                                          customer_check: checked ? 1 : 0,
                                        });
                                      }}
                                      id="customer_check"
                                    />
                                    <label
                                      class="form-check-label ms-2"
                                      for="customer_check"
                                      style={{ color: "black" }}
                                    >
                                      Fill with customer data
                                    </label>
                                  </div>
                                </div>

                                {wayBillData?.customer_check === 1 && (
                                  <div className="col-md-12">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("defualt_address")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <Select
                                            className="my-select-v"
                                            options={alternateAddressList}
                                            value={alternateAddressList.find(
                                              (item) =>
                                                item.value ===
                                                wayBillData.alternate_address_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              setWayBillData({
                                                ...wayBillData,
                                                alternate_address_id:
                                                  selectedOption
                                                    ? selectedOption.value
                                                    : "",
                                                delivery_destination_address:
                                                  selectedOption
                                                    ? selectedOption?.address
                                                    : "",
                                                delivery_destination_city:
                                                  selectedOption
                                                    ? selectedOption?.city
                                                    : "",
                                                delivery_destination_zip_code:
                                                  selectedOption
                                                    ? selectedOption?.zip_code
                                                    : "",
                                                delivery_destination_country:
                                                  selectedOption
                                                    ? selectedOption?.country_id
                                                    : "",
                                              });
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder={
                                              "Select Alternate Address"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>
                                )}

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("address")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <textarea
                                          className="form-control input-search"
                                          type="text"
                                          value={
                                            wayBillData.delivery_destination_address
                                          }
                                          onChange={(e) => {
                                            setWayBillData({
                                              ...wayBillData,
                                              delivery_destination_address:
                                                e.target.value,
                                            });
                                          }}
                                          name="delivery_destination_address"
                                          placeholder="Address"
                                          rows={3}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="row">
                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("zipCode")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <input
                                            className="form-control input-search"
                                            type="text"
                                            value={
                                              wayBillData.delivery_destination_zip_code
                                            }
                                            onChange={(e) => {
                                              setWayBillData({
                                                ...wayBillData,
                                                delivery_destination_zip_code:
                                                  e.target.value,
                                              });
                                            }}
                                            name="delivery_destination_zip_code"
                                            placeholder="Zip Code"
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-8">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("city")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <input
                                            className="form-control input-search"
                                            type="text"
                                            value={
                                              wayBillData.delivery_destination_city
                                            }
                                            onChange={(e) => {
                                              setWayBillData({
                                                ...wayBillData,
                                                delivery_destination_city:
                                                  e.target.value,
                                              });
                                            }}
                                            name="delivery_destination_city"
                                            placeholder="city"
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("country")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={countryList}
                                          value={countryList.find(
                                            (item) =>
                                              Number(item.value) ===
                                              Number(
                                                wayBillData.delivery_destination_country,
                                              ),
                                          )}
                                          onChange={(selectedOption) => {
                                            setWayBillData({
                                              ...wayBillData,
                                              delivery_destination_country:
                                                selectedOption
                                                  ? selectedOption.value
                                                  : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Country"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-12">
                                  <Button
                                    type="button"
                                    className="btn"
                                    onClick={handleShippingDelete}
                                    style={{
                                      color: "#ffffff",
                                      backgroundColor: "#dc3545",
                                      borderColor: "#dc3545",
                                      boxShadow: "none",
                                      padding: "6px 10px",
                                    }}
                                  >
                                    {t("deleteShippingInfo")}
                                  </Button>
                                </div>
                              </div>

                              <div className="col-md-6"></div>
                            </div>
                          </div>
                        </div>

                        <div className="section-box">
                          <div
                            className={`section-header-green ${
                              openNotes ? "active" : ""
                            }`}
                            onClick={() => setOpenNotes(!openNotes)}
                          >
                            <i
                              className={`bi ${
                                openNotes ? "bi-chevron-up" : "bi-chevron-down"
                              }`}
                            ></i>
                            <span className="ms-2">Notes</span>
                          </div>

                          <div
                            className={`collapse ${openNotes ? "show" : ""}`}
                          >
                            <div className="row mt-3">
                              <div className="col-md-12 mb-3">
                                <FormGroup>
                                  <Label className="Label-my">
                                    {t("notes")}
                                  </Label>
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={wayBillData.notes}
                                    onChange={(e) => {
                                      setWayBillData({
                                        ...wayBillData,
                                        notes: e.target.value,
                                      });
                                    }}
                                    name="notes"
                                    placeholder="Notes"
                                    rows={4}
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col ms-2">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => navigate("/waybills")}
                            >
                              <i className="bi bi-arrow-left"> </i> {t("back")}
                            </button>
                          </div>
                          <div className="col">
                            <div className="d-flex justify-content-end nxt-btn">
                              {btnLoader === true ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Loading...
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  {t("submit")} <i className="bi bi-check2"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card-primary d-none">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("products")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddProduct}
                              type="button"
                            >
                              + {t("add_product")}
                            </button>
                          </div>

                          {wayBillData?.products?.map((product, i) => (
                            <div key={i} className="card p-3 mb-3">
                              <h5>Product {i + 1}</h5>
                              <div className="row">
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("product")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={productList}
                                      value={productList.find(
                                        (item) =>
                                          item.value ===
                                          String(
                                            wayBillData.products[i].product_id,
                                          ),
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [...wayBillData.products];
                                        list[i].product_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setWayBillData({
                                          ...wayBillData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); // validation
                                        setSelectedProduct(selectedOption);
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Product"}
                                    />
                                    {errorsPro[i]?.product_id && (
                                      <small className="text-danger">
                                        {errorsPro[i].product_id}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("name")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Name"
                                      value={product.name}
                                      onChange={(e) => {
                                        let list = [...wayBillData.products];
                                        list[i].name = e.target.value;
                                        setWayBillData({
                                          ...wayBillData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); //validation
                                      }}
                                    />
                                    {errorsPro[i]?.name && (
                                      <small className="text-danger">
                                        {errorsPro[i].name}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("summary")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Summary"
                                      value={product.summary}
                                      onChange={(e) => {
                                        let list = [...wayBillData.products];
                                        list[i].summary = e.target.value;
                                        setWayBillData({
                                          ...wayBillData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("quantity")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Quantity"
                                      value={product.qty}
                                      onChange={(e) => {
                                        let list = [...wayBillData.products];
                                        list[i].qty = parseFloat(
                                          e.target.value,
                                        );
                                        setWayBillData({
                                          ...wayBillData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.qty && (
                                      <small className="text-danger">
                                        {errorsPro[i].qty}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("price")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Price"
                                      value={product.price}
                                      onChange={(e) => {
                                        let list = [...wayBillData.products];
                                        list[i].price = parseFloat(
                                          e.target.value,
                                        );
                                        setWayBillData({
                                          ...wayBillData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.price && (
                                      <small className="text-danger">
                                        {errorsPro[i].price}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("discount")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Discount"
                                      value={product.discount}
                                      onChange={(e) => {
                                        let list = [...wayBillData.products];
                                        list[i].discount = parseFloat(
                                          e.target.value,
                                        );
                                        setWayBillData({
                                          ...wayBillData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("deduction")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={deductionList}
                                      value={deductionList.find(
                                        (item) =>
                                          item.value ===
                                          wayBillData.products[i].deduction_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [...wayBillData.products];
                                        list[i].deduction_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setWayBillData({
                                          ...wayBillData,
                                          products: list,
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Deduction"}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("order")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Order"
                                      value={product.order}
                                      onChange={(e) => {
                                        let list = [...wayBillData.products];
                                        list[i].order = parseFloat(
                                          e.target.value,
                                        );
                                        setWayBillData({
                                          ...wayBillData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("exemption_reason")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={exemptionList}
                                          value={exemptionList.find(
                                            (item) =>
                                              item.value ===
                                              wayBillData.products[i]
                                                .exemption_reason,
                                          )}
                                          onChange={(selectedOption) => {
                                            let list = [
                                              ...wayBillData.products,
                                            ];
                                            list[i].exemption_reason =
                                              selectedOption
                                                ? selectedOption.value
                                                : null;
                                            setWayBillData({
                                              ...wayBillData,
                                              products: list,
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={
                                            "Select Exemption Reason"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-3"></div>

                                <div className="col-md-3"></div>
                                <div className="col-md-3"></div>

                                <div className="row">
                                  <div
                                    className="col-md-12"
                                    style={{
                                      marginTop: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    {" "}
                                    <h5>{t("tax")}</h5>
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) => handleAddTax(e, i)}
                                      type="button"
                                    >
                                      + {t("add_tax")}
                                    </button>
                                  </div>

                                  {product?.taxes?.map((prop, j) => (
                                    <div key={j} className="d-flex gap-2 mb-2">
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                                            {t("tax")}
                                          </Label>
                                          <Select
                                            className="my-select-v"
                                            options={taxDataList}
                                            value={taxDataList.find(
                                              (item) =>
                                                item.value ===
                                                String(
                                                  wayBillData.products[i].taxes[
                                                    j
                                                  ].tax_id,
                                                ),
                                            )}
                                            onChange={(selectedOption) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].taxes[j].tax_id =
                                                selectedOption
                                                  ? selectedOption.value
                                                  : null;
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder={"Select Tax"}
                                          />
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                                            {t("value")}
                                          </Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Value"
                                            value={prop.value}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].taxes[j].value =
                                                e.target.value;
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                                            {t("order")}
                                          </Label>
                                          <input
                                            type="Number"
                                            className="form-control"
                                            placeholder="Order"
                                            value={prop.order}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].taxes[j].order =
                                                e.target.value;
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-3 d-flex align-item-center">
                                        <FormGroup>
                                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                                            {t("cumulative")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <div className="form-check">
                                                <input
                                                  className="my-checkbox-1 form-check-input"
                                                  type="checkbox"
                                                  checked={
                                                    prop.cumulative === 1
                                                  }
                                                  onChange={(e) => {
                                                    let list = [
                                                      ...wayBillData.products,
                                                    ];
                                                    list[i].taxes[
                                                      j
                                                    ].cumulative = e.target
                                                      .checked
                                                      ? 1
                                                      : 0;
                                                    setWayBillData({
                                                      ...wayBillData,
                                                      products: list,
                                                    });
                                                  }}
                                                />
                                                <label className="form-check-label pl-2">
                                                  {t("Cumulative")}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </FormGroup>
                                        <button
                                          className="btn btn-danger"
                                          onClick={(e) =>
                                            handleRemoveTax(e, i, j)
                                          }
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={(e) => handleRemoveProduct(e, i)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>

                              <div className="row d-none">
                                <div
                                  className="col-md-12"
                                  style={{
                                    marginTop: "15px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <h5>{t("child_products")}</h5>
                                  <button
                                    className="btn btn-primary"
                                    onClick={(e) => handleAddChildProduct(e, i)}
                                    type="button"
                                  >
                                    + {t("add_child_product")}
                                  </button>
                                </div>

                                {product?.child_products?.map((child, k) => (
                                  <div key={k} className="card p-2 mb-2 border">
                                    <h6>Child Product {k + 1}</h6>

                                    <div className="row">
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("child_name")}</Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.name}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[k].name =
                                                e.target.value;
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("summary")}</Label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={child.summary}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].summary = e.target.value;
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("quantity")}</Label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={child.qty}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[k].qty =
                                                parseFloat(e.target.value);
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                      <div className="col-md-3">
                                        <FormGroup>
                                          <Label>{t("price")}</Label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={child.price}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[k].price =
                                                parseFloat(e.target.value);
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </FormGroup>
                                      </div>
                                    </div>

                                    {/* Properties Section for child */}
                                    <div className="row mt-2">
                                      <h6>{t("properties")}</h6>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={(e) =>
                                          handleAddChildProperty(e, i, k)
                                        }
                                        type="button"
                                      >
                                        + {t("add_property")}
                                      </button>
                                      {child?.properties?.map((prop, j) => (
                                        <div
                                          key={j}
                                          className="d-flex gap-2 mb-2"
                                        >
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Title"
                                            value={prop.title}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].properties[j].title =
                                                e.target.value;
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Value"
                                            value={prop.value}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[
                                                k
                                              ].properties[j].value =
                                                e.target.value;
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>

                                    {/* Taxes Section for child */}
                                    <div className="row mt-2">
                                      <h6>{t("taxes")}</h6>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={(e) =>
                                          handleAddChildTax(e, i, k)
                                        }
                                        type="button"
                                      >
                                        + {t("add_tax")}
                                      </button>
                                      {child?.taxes?.map((tax, j) => (
                                        <div
                                          key={j}
                                          className="d-flex gap-2 mb-2"
                                        >
                                          <Select
                                            className="my-select-v"
                                            options={taxDataList}
                                            value={taxDataList.find(
                                              (item) =>
                                                item.value === tax.tax_id,
                                            )}
                                            onChange={(selectedOption) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].tax_id = selectedOption
                                                ? selectedOption.value
                                                : null;
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                            isSearchable
                                            isClearable
                                            placeholder="Select Tax"
                                          />
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Value"
                                            value={tax.value}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].value = parseFloat(
                                                e.target.value,
                                              );
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Order"
                                            value={tax.order}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].order = parseFloat(
                                                e.target.value,
                                              );
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                          <input
                                            type="checkbox"
                                            checked={tax.cumulative === 1}
                                            onChange={(e) => {
                                              let list = [
                                                ...wayBillData.products,
                                              ];
                                              list[i].child_products[k].taxes[
                                                j
                                              ].cumulative = e.target.checked
                                                ? 1
                                                : 0;
                                              setWayBillData({
                                                ...wayBillData,
                                                products: list,
                                              });
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>

                                    {/* Remove child button */}
                                    <button
                                      className="btn btn-danger mt-2"
                                      onClick={(e) =>
                                        handleRemoveChildProduct(e, i, k)
                                      }
                                    >
                                      <i className="bi bi-trash"></i>{" "}
                                      {t("remove_child_product")}
                                    </button>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>

            <Modal isOpen={customerModel} size="xl">
              <ModalHeader>{t("CreateCustomer")}</ModalHeader>
              <Form method={`post`}>
                <ModalBody>
                  <div className="row">
                    <div className="mb-3">
                      {/* Tabs */}
                      <ul className="custom-tabs">
                        <li
                          className={
                            activeCustomerTab === "1"
                              ? "tab-item active"
                              : "tab-item"
                          }
                          onClick={() => setActiveCustomerTab("1")}
                        >
                          {t("main")}
                        </li>

                        <li
                          className={
                            activeCustomerTab === "2"
                              ? "tab-item active"
                              : "tab-item"
                          }
                          onClick={() => setActiveCustomerTab("2")}
                        >
                          {t("contact")}
                        </li>

                        <li
                          className={
                            activeCustomerTab === "3"
                              ? "tab-item active"
                              : "tab-item"
                          }
                          onClick={() => setActiveCustomerTab("3")}
                        >
                          {t("otherAddresses")}
                        </li>

                        <li
                          className={
                            activeCustomerTab === "4"
                              ? "tab-item active"
                              : "tab-item"
                          }
                          onClick={() => setActiveCustomerTab("4")}
                        >
                          {t("billingSettings")}
                        </li>
                      </ul>

                      <div className="tab-content-area">
                        {activeCustomerTab === "1" && (
                          <div className="row">
                            <div class="alert alert-light" role="alert">
                              NOTE: All required fields are marked with{" "}
                              <span style={{ color: "red" }}>(*)</span>
                            </div>

                            <p>General Information</p>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("vat")}{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.vat}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        vat: e.target.value,
                                      });
                                    }}
                                    name={`vat`}
                                    maxLength={50}
                                    placeholder="Vat"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("number")}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.number}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        number: e.target.value,
                                      });
                                    }}
                                    name={`number`}
                                    maxLength={50}
                                    placeholder="Number"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("Name")}{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.name}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        name: e.target.value,
                                      });
                                    }}
                                    name={`name`}
                                    maxLength={50}
                                    placeholder="Name"
                                  />
                                </div>
                                {errors.name && (
                                  <span className="input-error">
                                    {errors.name}
                                  </span>
                                )}
                              </FormGroup>
                            </div>
                            <div class="alert alert-primary" role="alert">
                              Fill with default data
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("address")}
                                </Label>
                                <span className="text-danger">*</span>

                                <div className="col-xl-12">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.address}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        address: e.target.value,
                                      });
                                    }}
                                    name={`address`}
                                    maxLength={50}
                                    placeholder="Address"
                                    rows={3}
                                  />
                                </div>
                              </FormGroup>
                            </div>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("city")}
                                </Label>
                                <span className="text-danger">*</span>

                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.city}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        city: e.target.value,
                                      });
                                    }}
                                    name={`city`}
                                    maxLength={50}
                                    placeholder="City"
                                  />
                                </div>
                              </FormGroup>
                            </div>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("zip_code")}
                                </Label>
                                <span className="text-danger">*</span>

                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.zip_code}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        zip_code: e.target.value,
                                      });
                                    }}
                                    name={`zip_code`}
                                    maxLength={50}
                                    placeholder="Zip code"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("country")}
                                </Label>
                                <span className="text-danger">*</span>

                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={countryList}
                                      value={countryList.find(
                                        (item) =>
                                          item.value == customerData.country_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          country_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Country"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("email")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.email}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        email: e.target.value,
                                      });
                                    }}
                                    name={`email`}
                                    maxLength={50}
                                    placeholder="Contact email"
                                  />
                                  {errors.email && (
                                    <span className="input-error">
                                      {errors.email}
                                    </span>
                                  )}
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4" />
                          </div>
                        )}

                        {activeCustomerTab === "2" && (
                          <div className="row">
                            <div class="alert alert-light" role="alert">
                              NOTE: All required fields are marked with{" "}
                              <span style={{ color: "red" }}>(*)</span>
                            </div>

                            <p>Contacts</p>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("phone")}
                                </Label>
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={customerData.phone}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        phone: e.target.value,
                                      });
                                    }}
                                    name={`phone`}
                                    placeholder="Phone"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("fax")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={customerData.fax}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        fax: e.target.value,
                                      });
                                    }}
                                    name={`fax`}
                                    placeholder="Fax"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("website")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.website}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        website: e.target.value,
                                      });
                                    }}
                                    name={`website`}
                                    placeholder="website"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("contactPerson")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.contact_person}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        contact_person: e.target.value,
                                      });
                                    }}
                                    name={`contact_person`}
                                    placeholder="Contact Person"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("contactEmail")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.contact_email}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        contact_email: e.target.value,
                                      });
                                    }}
                                    name={`contact_email`}
                                    placeholder="Contact Email"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("telephoneContact")}
                                </Label>
                                <div className="col-xl-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.telephone_contact}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        telephone_contact: e.target.value,
                                      });
                                    }}
                                    name={`telephone_contact`}
                                    placeholder="Telephone Contact"
                                  />
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-12">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("contactNotes")}
                                </Label>
                                <div className="col-xl-12">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.contact_notes}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        contact_notes: e.target.value,
                                      });
                                    }}
                                    name={`contact_notes`}
                                    placeholder="Contact Notes"
                                    rows={4}
                                  />
                                </div>
                              </FormGroup>
                            </div>
                          </div>
                        )}

                        {activeCustomerTab === "3" && (
                          <>
                            <div className="row">
                              <div className="alert alert-light" role="alert">
                                NOTE: All required fields are marked with{" "}
                                <span style={{ color: "red" }}>(*)</span>
                              </div>

                              <p>Alternate Address</p>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Description
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="description"
                                    value={altForm.description}
                                    onChange={handleAltChange}
                                    placeholder="Description"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Code
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="code"
                                    value={altForm.code}
                                    onChange={handleAltChange}
                                    placeholder="Code"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Zip Code
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="zip_code"
                                    value={altForm.zip_code}
                                    onChange={handleAltChange}
                                    placeholder="Zip Code"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    City
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="city"
                                    value={altForm.city}
                                    onChange={handleAltChange}
                                    placeholder="City"
                                  />
                                </FormGroup>
                              </div>

                              {/* Country */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Country
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <Select
                                    className="my-select-v"
                                    options={countryList}
                                    value={
                                      countryList.find(
                                        (item) =>
                                          item.value === altForm.country,
                                      ) || null
                                    }
                                    onChange={(selectedOption) => {
                                      setAltForm({
                                        ...altForm,
                                        country: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder="Select Country"
                                  />
                                </FormGroup>
                              </div>

                              {/* Email */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    E-mail
                                  </Label>
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="email"
                                    value={altForm.email}
                                    onChange={handleAltChange}
                                    placeholder="Email"
                                  />
                                </FormGroup>
                              </div>

                              {/* Phone */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Phone
                                  </Label>
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="phone"
                                    value={altForm.phone}
                                    onChange={handleAltChange}
                                    placeholder="Phone"
                                  />
                                </FormGroup>
                              </div>

                              {/* Fax */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Fax
                                  </Label>
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="fax"
                                    value={altForm.fax}
                                    onChange={handleAltChange}
                                    placeholder="Fax"
                                  />
                                </FormGroup>
                              </div>

                              {/* Contact Person */}
                              <div className="col-md-4">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Contact Person
                                  </Label>
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="contact_person"
                                    value={altForm.contact_person}
                                    onChange={handleAltChange}
                                    placeholder="Contact Person"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-12">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    Address
                                  </Label>
                                  <span className="text-danger">*</span>

                                  <textarea
                                    className="form-control input-search"
                                    rows={4}
                                    name="address"
                                    value={altForm.address}
                                    onChange={handleAltChange}
                                    placeholder="Address"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-12 mt-3">
                                <button
                                  className="btn btn-primary"
                                  onClick={saveAlternateAddress}
                                  type="button"
                                >
                                  {editIndex !== null
                                    ? "Update Address"
                                    : "Add Address"}
                                </button>
                              </div>
                            </div>

                            <div>
                              {billLadingData?.alternate_address?.length >
                                0 && (
                                <table className="table table-bordered mt-4">
                                  <thead>
                                    <tr>
                                      <th>Code</th>
                                      <th>City</th>
                                      <th>Country</th>
                                      <th>Email</th>
                                      <th style={{ width: "120px" }}>
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {billLadingData?.alternate_address?.map(
                                      (item, index) => (
                                        <tr key={index}>
                                          <td>{item.code}</td>
                                          <td>{item.city}</td>
                                          <td>{item.country}</td>
                                          <td>{item.email}</td>
                                          <td>
                                            <div className="d-flex gap-2">
                                              <button
                                                className="btn btn-sm"
                                                type="button"
                                                onClick={() =>
                                                  editAlternateAddress(index)
                                                }
                                              >
                                                <i className="bi bi-pencil"></i>
                                              </button>

                                              <button
                                                className="btn btn-sm"
                                                type="button"
                                                onClick={() =>
                                                  deleteAlternateAddress(index)
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </>
                        )}

                        {activeCustomerTab === "4" && (
                          <div className="row">
                            <div className="alert alert-light" role="alert">
                              NOTE: All required fields are marked with{" "}
                              <span style={{ color: "red" }}>(*)</span>
                            </div>

                            <p>Billing Settings</p>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("language")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={languageList}
                                      value={languageList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.language_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          language_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Language"}
                                    />
                                    {errors.language_id && (
                                      <span className="input-error">
                                        {errors.language_id}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("PriceTablesByDefault")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={priceClassList}
                                      value={priceClassList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.price_class_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          price_class_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={
                                        "Select Price Tables By Default"
                                      }
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("Maturity")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={maturityDatesList}
                                      value={maturityDatesList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.maturity_date_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          maturity_date_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Maturity"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("payment_day")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search"
                                      type="number"
                                      value={customerData.payment_day}
                                      onChange={(e) => {
                                        setCustomerData({
                                          ...customerData,
                                          payment_day: e.target.value,
                                        });
                                      }}
                                      name={`payment_day`}
                                      maxLength={50}
                                      placeholder="Payment day"
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("globalDiscount")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search"
                                      type="number"
                                      value={customerData.global_discount_id}
                                      onChange={(e) => {
                                        setCustomerData({
                                          ...customerData,
                                          global_discount_id: e.target.value,
                                        });
                                      }}
                                      name={`global_discount_id`}
                                      maxLength={50}
                                      placeholder="Global Discount"
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("credit_limit")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search"
                                      type="number"
                                      value={customerData.credit_limit}
                                      onChange={(e) => {
                                        setCustomerData({
                                          ...customerData,
                                          credit_limit: e.target.value,
                                        });
                                      }}
                                      name={`credit_limit`}
                                      maxLength={50}
                                      placeholder="Credit limit"
                                    />
                                    {errors.credit_limit && (
                                      <span className="input-error">
                                        {errors.credit_limit}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("paymentMethod")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={paymentMethodList}
                                      value={paymentMethodList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.payment_method_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          payment_method_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Payment Method"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("deliveryMethod")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={deliveryMethodList}
                                      value={deliveryMethodList.find(
                                        (item) =>
                                          item.value ==
                                          customerData.delivery_method_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          delivery_method_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Payment Method"}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("salesmen")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <Select
                                      className="my-select-v"
                                      options={salesmenList}
                                      value={salesmenList.find(
                                        (item) =>
                                          item.value ===
                                          customerData.salesman_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        setCustomerData({
                                          ...customerData,
                                          salesman_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Salesmen"}
                                    />
                                    {errors.salesman_id && (
                                      <span className="input-error">
                                        {errors.salesman_id}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my">
                                  {t("notes")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      className="form-control input-search"
                                      type="text"
                                      value={customerData.notes}
                                      onChange={(e) => {
                                        setCustomerData({
                                          ...customerData,
                                          notes: e.target.value,
                                        });
                                      }}
                                      name={`notes`}
                                      maxLength={50}
                                      placeholder="notes"
                                    />
                                  </div>
                                  {errors.notes && (
                                    <span className="input-error">
                                      {errors.notes}
                                    </span>
                                  )}
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4" />
                            <div className="col-md-4" />
                            <div className="col-md-4" />
                            <div className="col-md-4" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <button
                    type="button"
                    className="btn btn-block btn-primary"
                    disabled={isModifyButtonLoad}
                    onClick={handleCustomerCloseModel}
                    style={{ width: "100px", marginTop: "10px" }}
                  >
                    {t("close")} <i className="bi bi-x-lg"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "120px" }}
                    disabled={isModifyButtonLoad}
                    onClick={handleCustomerSubmit}
                  >
                    {isModifyButtonLoad ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                        Loading...
                      </>
                    ) : (
                      <>
                        {t("submit")} <i className="bi bi-check2"></i>
                      </>
                    )}
                  </button>
                </ModalFooter>
              </Form>
            </Modal>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddWaybills;
